module.exports = __webpack_public_path__ + "static/pic03-120f5910f1a38334327d384d599861c4.jpg";